import { formatDate } from "./dateFormater"

export const formatedDates = (dateOne: Date, dateTwo: Date): { termdate: string, currentDate: string } => {
  return {
    termdate: formatDate(dateOne),
    currentDate: formatDate(dateTwo)
  }
}

export const formatedDateTemporality = (dateOne: Date, dateTwo: Date): { temporalitydate: string, currentDateTemporality: string } => {
  return {
    temporalitydate: formatDate(dateOne),
    currentDateTemporality: formatDate(dateTwo)
  }
}

export const formatDateNow = (): string => {
  const now = new Date();

  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0'); 
  const year = now.getFullYear();

  const hour = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  return `${month}/${day}/${year} ${hour}:${minutes}:${seconds}`;
}